import React, { useState, useEffect } from 'react';
import AssetChatbot from './AssetChatbot';
import { IoMdChatbubbles } from 'react-icons/io';
import './AssetChatbot.css';

const AssetChatbotWrapper = ({ loadingFile, chatbotPopupOpen, onClose }) => {
  const [open, setOpen] = useState(false);

  // When parent instructs to open, open the widget
  useEffect(() => {
    if (chatbotPopupOpen === true) setOpen(true);
  }, [chatbotPopupOpen]);

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    if (onClose) onClose(); // keep original onClose behavior
  };

  return (
    <>
      {/* Keep the chatbot component mounted always, control visibility via prop */}
      <div className="chatbot-floating-wrapper">
        <AssetChatbot
          loadingFile={loadingFile}
          onClose={handleClose}
          visible={open}
        />
      </div>

      {/* Floating toggle button (only shown when closed) */}
      {!open && (
        <div className="chatbot-toggle-button" onClick={handleOpen}>
          <IoMdChatbubbles size={24} />
        </div>
      )}
    </>
  );
};

export default AssetChatbotWrapper;
